import { Stack } from '@mui/material';
import { ControlledDropdown } from 'Components/ControlledDropdown';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { AllFilters } from '../AllFilters';
import { Specialties } from './Specialties';
import { General } from './General';
import { useContext, useEffect, useState } from 'react';
import { TherapySuppliersContext } from 'Context/SuppliersContext/TherapySuppliersContext';

export const TherapyFilter = () => {
  const { filters, suppliers } = useContext(TherapySuppliersContext);
  const [supplierChangeDetection, setSupplierChangeDetection] =
    useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  useEffect(() => {
    setSupplierChangeDetection((prev) => !prev);
  }, [suppliers.filteredResults]);

  return (
    <Stack
      direction='row'
      gap='24px'
      sx={{
        width: 'fit-content',
        minHeight: '50px',
        flexWrap: 'wrap',
      }}
    >
      {isDesktop && (
        <>
          <ControlledDropdown
            label={dictionary.therapy.sort}
            filterComponent={<General />}
            activeFilters={
              (filters.orderByAscendingAlphabet ||
              filters.orderByDescendingAlphabet
                ? 1
                : 0) + (filters.location ? 1 : 0)
            }
            closeOnEffect={supplierChangeDetection}
          />
          <ControlledDropdown
            label={dictionary.therapy.therapyMethods}
            filterComponent={<Specialties />}
            activeFilters={filters.treatMethod?.length}
          />
        </>
      )}
      <AllFilters openModal={openModal} setOpenModal={setOpenModal} />
    </Stack>
  );
};
